import DemandCollectionActionTypes from './demand-collection-report.types';

/** ***************** GET DEMAND COLLECTION LIST START *********************** */
export const getDemandCollectionDetailsStart = (getData: any) => ({
	type: DemandCollectionActionTypes.GET_DEMAND_COLLECTION_LIST_START,
	payload: getData,
});

export const getDemandCollectionDetailsSuccess = (successData: any) => ({
	type: DemandCollectionActionTypes.GET_DEMAND_COLLECTION_LIST_SUCCESS,
	payload: successData,
});

export const getDemandCollectionDetailsFailure = (failureData: any) => ({
	type: DemandCollectionActionTypes.GET_DEMAND_COLLECTION_LIST_FAILURE,
	payload: failureData,
});

export const getDemandCollectionDetailsResponseResetStart = () => ({
	type: DemandCollectionActionTypes.GET_DEMAND_COLLECTION_LIST_RESPONSE_RESET,
});

export const getDemandCollectionDetailsResponseChanged = () => ({
	type: DemandCollectionActionTypes.GET_DEMAND_COLLECTION_LIST_RESPONSE_CHANGED,
});
/** ***************** GET DEMAND COLLECTION LIST END *********************** */
